import { createFileRoute } from '@tanstack/react-router'
import { PublicInvoicePage } from '../features/sales/public-invoice-page'

/**
 * A shared invoice (`/p/:token`): outside the signed-in layout, so no session is asked for and
 * nobody is sent to the sign-in page. The token is the only key (GET /public/documents/:token).
 */
export const Route = createFileRoute('/p/$token')({
  component: PublicInvoicePage,
})
